const AccountLayout = ({ nav, children }) => (
  <div className="min-h-screen bg-gradient-to-br from-[#050815] via-[#0a0f1f] to-[#050815] text-slate-100">
    <div className="flex h-screen w-full overflow-hidden">
      {nav}
      <main className="flex h-full flex-1 flex-col gap-4 overflow-y-auto px-8 py-10">{children}</main>
    </div>
  </div>
);

export default AccountLayout;
